<template lang="pug">
v-col(sm='3')
  v-card
    v-card-title
      .headline {{data.Name}}
      v-spacer
      v-btn.mr-2(icon @click='download')
        v-icon mdi-download
      v-dialog(v-if='user.ID === data.OwnerID' v-model='dialog' width='500')
        template(v-slot:activator='{ on }')
          v-btn(icon v-on='on')
            v-icon mdi-share
        v-card
          v-card-title.headline(primary-title) Shared settings
          v-card-text
            v-container
              v-select(v-model='selectedShared' :items='flatMembers' chips label='Company members' multiple @input='changeInput')
          v-divider
          v-card-actions
            v-spacer
            v-btn(text @click='dialog = false')
              | Close
      v-chip(v-else-if='!data.prc') shared
    v-card-text
      v-progress-linear(v-if='data.prc' v-model='data.prc' color='deep-purple accent-4')
      .d-flex(v-else)
        v-btn(color='primary' block @click='openDoc') view
</template>

<script>
const FileDownload = require('js-file-download');

export default {
  props: ['data', 'members'],
  data() {
    return {
      dialog: false,
      selectedShared: this.data.SharedWith ? this.data.SharedWith.map(v => v.ID) : [],
    }
  },
  computed: {
    flatMembers() {
      return this.members.map(v => ({text: v.first_name + " " + v.last_name, value: v.ID }))
    },
    user() {
      return this.$auth.user()
    }
  },
  methods: {
    openDoc() {
      const arr = this.data.Name.split(".")
      let fileType = "";
      switch (arr[arr.length - 1]) {
        case "jpg":
        case "jpeg":
        case "png":
          fileType = "img"
          break
        default:
          fileType = "doc"
      }
      this.$store.commit("openDoc", { type: fileType, url: process.env.VUE_APP_API_URL + "/document/" + this.data.ID })
      
    },
    changeInput(val) {
      this.axios.put('files/share/' + this.data.ID, { SharedIds: val })
    },
    download() {
      this.axios.get('/files/download/' + this.data.ID, {responseType: 'blob'}).then(resp => {
        FileDownload(resp, this.data.Name)
      })
    }
  }
}
</script>